import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentFeatureMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentFeatureMediaFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { ContentDetails_Person_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsPersonContentReferenceFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiArticle_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  description?: string | null
  descriptionFormat?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  seoDescription?: string | null
  seoTitle?: string | null
  title?: string | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiArticleTopic?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiArticle_ContentFragmentFragmentDoc = gql`
  fragment YIArticle_ContentFragment on Content {
    contentPolicyPolicyId
    id
    contentId
    contentType
    language
    description
    descriptionFormat
    shortDescription
    shortDescriptionFormat
    path
    primaryLanguage
    published
    publishedAtDate
    seoDescription
    seoTitle
    title
    ...ContentFeatureMediaFragment
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiYogaTeacher: contentReferencesFrom(types: "yi-yoga-teacher") {
      ...ContentDetails_Person_ContentReferenceFragment
    }
    yiTags: contentReferencesFrom(types: "yi-tag") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiArticleTopic: contentReferencesFrom(types: "yi-article-topic") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentFeatureMediaFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${ContentDetails_Person_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
